import { render, staticRenderFns } from "./kukdong1.vue?vue&type=template&id=65a6ab60&scoped=true"
import script from "./kukdong1.vue?vue&type=script&lang=js"
export * from "./kukdong1.vue?vue&type=script&lang=js"
import style0 from "./kukdong1.vue?vue&type=style&index=0&id=65a6ab60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6ab60",
  null
  
)

export default component.exports